<template>
  <van-dialog v-model="value" :show-cancel-button="false" confirmButtonText="知道了" confirmButtonColor="#0052D9">
    <div class="max-price">
      <span style='color: #333;font-weight: bold;'>亲，今日的支付次数已到上限哦~</span><br>
      <span style="color: #595959;">你可以：</span>
      <span style='color: #333;font-weight: bold;'>1、<i style="color: #FF6634;font-weight: bold;text-decoration-line: underline;" @click="onKefuClick">联系客服</i> 进行处理</span>
      <span style='color: #333;font-weight: bold;'>2、明日再来购买</span>
    </div>
  </van-dialog>
</template>

<script>

export default {
  props: {
    value: [Boolean],
  },
  data() {
    return {
      show: false,
    }
  },
  watch: {
    value(val){
      this.show = val;
    },
    show(val){
      this.$emit('input', val)
    }
  },
  created() {
  },
  components: {

  },
  computed: {
  },
  methods: {
    onKefuClick() {
      this.show = false;
      window.location.href = 'https://300094.sh.absoloop.com/webim/im.html?configId=bda4de80-6e5c-11ef-b8aa-53197c42598f&language=zh-CN'
    },
  }
}
</script>

<style scoped lang="less">
.max-price {
  padding: 64px 48px;
  display: flex;
  flex-direction: column;
  align-items: center;

  >span {
    text-align: center;
    line-height: 48px;
  }
}
</style>
